import { render, staticRenderFns } from "./table-field-item.vue?vue&type=template&id=5b3c8c84&scoped=true&"
import script from "./table-field-item.vue?vue&type=script&lang=js&"
export * from "./table-field-item.vue?vue&type=script&lang=js&"
import style0 from "./table-field-item.vue?vue&type=style&index=0&id=5b3c8c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c8c84",
  null
  
)

export default component.exports